import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import ja from "date-fns/locale/ja";
import moment from "moment";

import {
  WrapperDateRangePickerFirst,
  WrapperDateRangePickerSecond,
  Text,
  CalendarIconStyled,
} from "./DateRangePicker.style";

registerLocale("ja", ja);
const dateFormat = "yyyy/MM/dd";
const CustomHeaderWrapper = (dateFormat: string) => {
  return function CustomHeader({
    monthDate,
    decreaseMonth,
    increaseMonth,
  }: any) {
    return (
      <>
        <button
          aria-label="Previous Month"
          className={
            "react-datepicker__navigation react-datepicker__navigation--previous"
          }
          onClick={(e: any) => {
            e.preventDefault();
            decreaseMonth();
          }}
        >
          <span
            className={
              "react-datepicker__navigation-icon react-datepicker__navigation-icon--previous"
            }
          >
            {"<"}
          </span>
        </button>
        <div className="react-datepicker__current-month">
          {format(monthDate, dateFormat)}
        </div>
        <button
          aria-label="Next Month"
          className={
            "react-datepicker__navigation react-datepicker__navigation--next"
          }
          onClick={(e: any) => {
            e.preventDefault();
            increaseMonth();
          }}
        >
          <span
            className={
              "react-datepicker__navigation-icon react-datepicker__navigation-icon--next"
            }
          >
            {">"}
          </span>
        </button>
      </>
    );
  };
};

const DateRangePicker = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  highlightDates,
  locale = "ja",
  renderDayContents,
  maxDate = true,
  minDate = false,
}: any) => {
  return (
    <div style={{ display: "inline-flex" }}>
      <WrapperDateRangePickerFirst>
        <div style={{ display: "flex", position: "relative" }}>
          <DatePicker
            dateFormat={dateFormat}
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            renderCustomHeader={CustomHeaderWrapper("yyyy年L月")}
            highlightDates={highlightDates}
            locale={locale}
            maxDate={maxDate ? new Date() : endDate}
            renderDayContents={renderDayContents}
            placeholderText="指定なし"
            minDate={minDate ? moment().toDate() : null}
          />

          <CalendarIconStyled />
        </div>
      </WrapperDateRangePickerFirst>
      <Text>~</Text>
      <WrapperDateRangePickerSecond>
        <div style={{ display: "flex", position: "relative" }}>
          <DatePicker
            dateFormat={dateFormat}
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            renderCustomHeader={CustomHeaderWrapper("yyyy年L月")}
            highlightDates={highlightDates}
            locale={locale}
            maxDate={maxDate ? new Date() : undefined}
            renderDayContents={renderDayContents}
            placeholderText="指定なし"
          />
          <CalendarIconStyled />
        </div>
      </WrapperDateRangePickerSecond>
    </div>
  );
};

export default DateRangePicker;
